<template>
<div
    v-if="isAvailable"
    :class="[badgeClasses, themeClasses]"
    class="w-15 aspect-square flex flex-col justify-center items-center gap-1 absolute z-10 text-white text-xs font-bold p-2 rounded-full shadow-lg"
>
    <div>
      <svg :width="iconSize.width" :height="iconSize.height" viewBox="0 0 31 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.90434 17.7503C11.3487 17.7503 12.5196 16.5794 12.5196 15.1349C12.5196 13.6904 11.3487 12.5195 9.90434 12.5195C8.45996 12.5195 7.28906 13.6904 7.28906 15.1349C7.28906 16.5794 8.45996 17.7503 9.90434 17.7503Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.9786 17.7503C24.423 17.7503 25.5938 16.5794 25.5938 15.1349C25.5938 13.6904 24.423 12.5195 22.9786 12.5195C21.5341 12.5195 20.3633 13.6904 20.3633 15.1349C20.3633 16.5794 21.5341 17.7503 22.9786 17.7503Z"
          stroke="white"
          stroke-width="1.5"
          stroke-miterlimit="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5841 15.1346H19.0569V1.53461C19.0569 1.10129 18.7057 0.75 18.2724 0.75H0.75"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M6.83243 15.1347H4.15177C3.71846 15.1347 3.36719 14.7834 3.36719 14.3501V7.94238"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path d="M2.05859 4.67285H7.28915" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M19.0586 4.67285H26.3946C26.7046 4.67285 26.9856 4.85546 27.1116 5.13881L29.4521 10.4052C29.4967 10.5057 29.5197 10.6142 29.5197 10.7239V14.3498C29.5197 14.7831 29.1685 15.1344 28.7351 15.1344H26.2506"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path d="M19.0586 15.1348H20.3662" stroke="white" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </div>
    <div class="text-center leading-tight" :class="textClasses">
        {{ t('products.free_shipping_badge') }}
    </div>
</div>
</template>

<script setup lang="ts">
interface Props {
  isAvailable?: boolean;
  size?: 'small' | 'medium' | 'large';
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const props = withDefaults(defineProps<Props>(), {
  isAvailable: false,
  size: 'medium',
  position: 'bottom-left',
});

const { t } = useI18n();
const config = useRuntimeConfig();

// Size configurations
const sizeConfig = {
  small: {
    container: 'w-16 aspect-square p-2',
    icon: { width: 24, height: 15 },
    text: 'text-[10px]',
  },
  medium: {
    container: 'w-24 aspect-square p-3',
    icon: { width: 28, height: 18 },
    text: 'text-xs',
  },
  large: {
    container: 'w-32 aspect-square p-4',
    icon: { width: 62, height: 38 },
    text: 'text-sm',
  },
};

// Position configurations
const positionConfig = {
  'top-left': 'top-4 left-4',
  'top-right': 'top-4 right-4',
  'bottom-left': 'bottom-4 left-4',
  'bottom-right': 'bottom-4 right-4',
};

// Theme-based background colors
const themeClasses = computed(() => {
  const theme = config.public.app_theme;
  return theme == 'red' ? 'bg-primary' : 'bg-green-500';
});

// Computed classes
const badgeClasses = computed(() => [sizeConfig[props.size].container, positionConfig[props.position]]);

const iconSize = computed(() => sizeConfig[props.size].icon);

const textClasses = computed(() => sizeConfig[props.size].text);
</script>
